import {
  ButtonHTMLAttributes,
  ForwardedRef,
  ReactNode,
  forwardRef,
} from "react";
import classNames from "classnames";
import "./btn.scss";

// 버튼 스타일 타입
type ButtonVariant = "primary" | "secondary" | "outline";
type ButtonSize = "sm" | "md" | "lg";
type ButtonRole =
  | "search"
  | "add"
  | "reset"
  | "detail"
  | "edit"
  | "delete"
  | "cancel"
  | "create";

export type Ref = HTMLButtonElement;

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size: ButtonSize;
  role: ButtonRole;
  text: string;
  formId?: string;
  fullWidth?: boolean;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  // children: ReactNode;
}

function Button(
  {
    text,
    type,
    formId,
    role,
    disabled,
    fullWidth,
    hidden,
    ...rest
  }: ButtonProps,
  ref: ForwardedRef<HTMLButtonElement>
) {
  const getColor = (role: ButtonRole) => {
    switch (role) {
      case "add":
        return "bg-red-300";
      case "search":
        return "bg-navy-600";
      case "reset":
        return "bg-gray-300";
    }
  };

  const btnClass = classNames(
    `${rest.className ?? ""} btn-${rest.variant} btn-${rest.size} 
    ${getColor(role)} 
    ${fullWidth ? "w-full" : "w-auto"}`
  );

  return (
    <button
      type={type}
      hidden={hidden}
      ref={ref}
      className={btnClass}
      data-role={role}
      disabled={disabled}
      form={formId}
      {...rest}
    >
      {text}
    </button>
  );
}

export default forwardRef<HTMLButtonElement, ButtonProps>(Button);
